
import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { faqPricing } from '../../../mocks/pricingData';

export default function PricingFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="py-20 bg-gradient-to-b from-white to-slate-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-voyage-gold/10 rounded-full mb-4">
            <i className="ri-question-line text-voyage-gold"></i>
            <span className="font-inter text-sm font-semibold text-voyage-gold">FAQ Tarifs</span>
          </div>
          <h2 className="font-playfair text-3xl md:text-4xl font-bold text-night-blue mb-3">
            Questions fréquentes sur nos tarifs
          </h2>
          <p className="font-inter text-slate-600 max-w-2xl mx-auto">
            Tout ce que vous devez savoir sur notre politique tarifaire
          </p>
        </motion.div>

        <div className="space-y-3" itemScope itemType="https://schema.org/FAQPage">
          {faqPricing.map((faq, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.05 }}
              itemScope
              itemProp="mainEntity"
              itemType="https://schema.org/Question"
              className="bg-white rounded-xl border border-slate-100 shadow-sm overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer group"
              >
                <span itemProp="name" className="font-inter text-sm font-semibold text-night-blue pr-4 group-hover:text-voyage-gold transition-colors">
                  {faq.question}
                </span>
                <div className={`w-8 h-8 flex items-center justify-center rounded-lg transition-all flex-shrink-0 ${
                  openIndex === index ? 'bg-voyage-gold text-white rotate-180' : 'bg-slate-100 text-slate-500'
                }`}>
                  <i className="ri-arrow-down-s-line text-lg"></i>
                </div>
              </button>
              <AnimatePresence>
                {openIndex === index && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.25 }}
                    className="overflow-hidden"
                    itemScope
                    itemProp="acceptedAnswer"
                    itemType="https://schema.org/Answer"
                  >
                    <div className="px-6 pb-5">
                      <p itemProp="text" className="font-inter text-sm text-slate-600 leading-relaxed">
                        {faq.answer}
                      </p>
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
